<template>
    <v-app>
        <template>
            <SignedInView
                    v-if="isSignedIn"
            ></SignedInView>
            <NotSignedInView
                v-if="isNotSignedIn">
            </NotSignedInView>
        </template>
    </v-app>
</template>

<script>
import { Amplify, Hub, } from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';

import SignedInView from '@/components/SignedInView.vue'
import NotSignedInView from '@/components/NotSignedInView.vue'
import { determineUserRole } from '@/determine-user-role';
import { peek } from '@/tools';

peek; // lint

Amplify.configure( aws_exports );

export default {
    name: 'App',

    created() {
        document.title = 'Monitor de Temperaturas';
        this.globalState = this.$root.$data.globalState;

        // TODO: Move all this initialization code to main.js

        Hub.listen( 'monitor', data => {
            if ( data.payload.event !== 'ev:isSignedIn' )
                return;

            this.initUserRole();
            this.computeSignedInFlags( data.payload.data );
        } );

        this.computeSignedInFlags( this.globalState.isSignedIn );
    },

    components: {
        SignedInView,
        NotSignedInView
    },

    computed: {
    },

    data: () => ({
        globalState : {},
        isSignedIn : false,
        isNotSignedIn : true,
    }),

    methods : {

        computeSignedInFlags( isSignedIn ) {
            this.isSignedIn = isSignedIn
            this.isNotSignedIn = ! isSignedIn;
        },

        initUserRole() {
            determineUserRole()
                .then( userRole => this.globalState.setUserRole( userRole ) );
        },
    },
};
</script>
